import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { IFiscalSetupProvider } from 'src/app/xena-api/dtos';
import { IQueryStringFilter, defaultListOptionsFilter } from 'src/app/xena-api/filters';
import {  Page } from 'src/app/xena-api/response-types';
@Injectable({
  providedIn: 'root'
})
export class ProviderService {

  constructor(private xenaClient: XenaClient) {
  }
  list(filter: IQueryStringFilter = defaultListOptionsFilter): Observable<Page<IFiscalSetupProvider>> {
    const resourcePath: string = '/Home/Provider';
    return this.xenaClient.list<IFiscalSetupProvider, IQueryStringFilter>(resourcePath, filter);
  }
}
